// SymbolEmoji enums
export const SymbolEmoji = Object.freeze({
  MULTIPLY: "multiply",
  RED_MULTIPLY: "red_multiply",
  RIGHT_ARROW: "right_arrow",
  RIGHT_ARROW_DISABLED: "right_arrow_disabled",
  LEFT_ARROW: "left_arrow",
  LEFT_ARROW_DISABLED: "left_arrow_disabled",
});
